import type { ColumnsType } from "antd/es/table";
import { Button } from "antd";
import { langCommon, langPage, langTableColumns } from "../../../locales";
import { FormConfigType } from "../../../components/editForm";

const lang = langPage?.card.main;

export const DEFAULT_QUERY_DATA = {
    CardProductId: null,
    MemberId: null,
    UdpayCardBin: null,
    UdpayCardStatus: null,
    CardholderEmail: null,
    Email: null,
    UdpayMaskedCardNumber: null
};

export const generateQueryFormConfig = (props: any): FormConfigType => {
    const { udpayOrderStatusOptions } = props;

    return [
        {
            title: lang?.cardProductId,
            type: "input",
            field: "CardProductId",
            allowClear: true,
        },
        {
            title: '用户邮箱',
            type: "input",
            field: "Email",
            allowClear: true,
        },
        {
            title: '持卡人邮箱',
            type: "input",
            field: "CardholderEmail",
            allowClear: true,
        },
        {
            title: langPage?.card?.memberId,
            type: "input",
            field: "MemberId",
            allowClear: true,
        },
        {
            title: langPage?.card?.udpayCardBin,
            type: "input",
            field: "UdpayCardBin",
            allowClear: true,
        },
        {
            title: '卡状态',
            type: "select",
            field: "UdpayCardStatus",
            allowClear: true,
            style: { width: 200 },
            options: udpayOrderStatusOptions
        },
        {
            title: '卡片搜索',
            type: "input",
            field: "UdpayMaskedCardNumber",
            allowClear: true,
        },
    ];
}

export const generateTableColumns = (props: any): ColumnsType => {
    const { operationRef, asyncCard } = props;
    return [
        {
            title: '遮罩卡号',
            dataIndex: "UdpayMaskedCardNumber",
        },
        {
            title: lang?.member,
            dataIndex: "Member",
            render(value, record, index) {
                return value?.Email || ''
            },
        },
        {
            title: '持卡人邮箱',
            dataIndex: "CardHolder",
            render(value, record, index) {
                return value?.Email || ''
            },
        },
        {
            title: langPage?.card.udpayCardBin,
            dataIndex: "UdpayCardBin",
        },
        {
            title: langPage?.card?.udpayCardScheme,
            dataIndex: "UdpayCardScheme",
        },
        {
            title: lang?.udpayCardCurrency,
            dataIndex: "UdpayCardCurrency",
        },
        {
            title: lang?.udpayAvailableBalance,
            dataIndex: "UdpayAvailableBalance",
        },
        {
            title: '卡片状态',
            dataIndex: "UdpayCardStatus",
        },
        {
            title: '卡片uuid',
            dataIndex: "UdpayCardId",
        },
        {
            title: langTableColumns?.CreatedAtString,
            dataIndex: "CreatedAtString",
        },
        {
            title: langTableColumns?.operation,
            dataIndex: "ops",
            width: 160,
            fixed: "right",
            render: (_: any, row: any) => {
                return (
                    <div>
                        <Button size="small" type="link"
                            onClick={() => {
                                asyncCard({ CardId: row.Id })
                            }}
                        >刷新卡片</Button>
                        <Button size="small" type="link" className="pdl0"
                            onClick={() => operationRef?.current?.changeVisible(row, 'update')}
                        >{langCommon?.modify}</Button>
                    </div>
                )
            }
        }
    ]
}


export const DEFAULT_OPERATION_DATA = {
    CardId: null,
    UdpayCardStatus: null,
}

export const generateOperationFormConfig = (props: any): FormConfigType => {
    // const { options } = props;
    return [
        {
            title: '卡片状态',
            type: "select",
            field: "UdpayCardStatus",
            options: [
                {
                    id: 'ACTIVE',
                    name: 'ACTIVE'
                },
                {
                    id: 'INACTIVE',
                    name: 'INACTIVE'
                }
            ],
            rules: [{
                required: true,
                message: `${langCommon?.pleaseSelect} 卡片状态`
            }]
        },
    ];
}